export default __webpack_public_path__ + "static/media/playlistSchedule.a40f0de4.svg";